import React from 'react';
import { useWindowSize } from 'react-use';
import cn from 'classnames';

import IMG_TOOLTIP from 'assets/images/kpi/kpi-tooltip-content.png';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import Tooltip from 'components/generic/Tooltip.component';
import MOBILE_VIEWPORT from 'constants/ui/mobileViewport.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './KpiHowToTooltip.module.scss';

const TooltipContent = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TooltipContent" className={CN.tooltipLearnMore}>
      <div className={CN.tooltipTitle}>{t('staffKpisReports.kpiReports.howToTooltip.title')}</div>
      <div className={CN.tooltipText}>
        {t('staffKpisReports.kpiReports.howToTooltip.text')}
        <img src={IMG_TOOLTIP} alt="How KPIs calculate hover illustration" className={CN.tooltipImg} />
      </div>
    </div>
  );
};

const KpiHowToTooltip = ({ variant, ...extra }) => {
  const { isDarkMode } = useTheme();
  const { width: windowWidth } = useWindowSize();
  const { t } = useTranslation();

  const isMobileViewport = windowWidth <= MOBILE_VIEWPORT;
  const tooltipSize = isMobileViewport ? 'md' : 'l3';
  const isIconOnly = variant === 'iconOnly';
  const tooltipVariant = isIconOnly ? 'leftToBottom' : 'bottomBottom';

  return (
    <div
      {...extra}
      data-bem="KpiHowToTooltip"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <Tooltip variant={tooltipVariant} width={tooltipSize} content={<TooltipContent />}>
        <Button variant={isIconOnly ? 'bin' : 'icon'} onClick={alwaysNoop}>
          <div
            data-bem="KpiSummary__button-tooltip"
            className={isIconOnly ? CN.buttonTooltipIconOnly : CN.buttonTooltipContainer}
          >
            <Icon variant="questionSolid" width="lg" />
            {!isIconOnly && (
              <span className={CN.toolbarTooltipText}>{t('staffKpisReports.kpiReports.howToTooltip.title')}</span>
            )}
          </div>
        </Button>
      </Tooltip>
    </div>
  );
};

export default KpiHowToTooltip;
